module.exports = __webpack_public_path__ + "static/media/contact_banner.f4ecc46e.svg";